var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProbleme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1805 2H8.28826L2 8.28826V17.1805L8.28826 23.4687H17.1805L23.4687 17.1805V8.28826L17.1805 2Z",
    stroke: "#F07F3C",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.657 10.3595C11.657 11.5911 11.6509 12.8226 11.657 14.0542C11.664 15.1406 12.7599 15.7847 13.6943 15.251C14.1497 14.9903 14.3644 14.5687 14.3653 14.0533C14.3705 11.5902 14.3705 9.1276 14.3653 6.66561C14.3653 5.86512 13.7569 5.27497 12.9998 5.27932C12.2428 5.28367 11.6596 5.88772 11.657 6.68647C11.6535 7.91022 11.657 9.13485 11.657 10.3595Z",
    fill: "#F07F3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6583 18.8232C11.656 19.0919 11.7337 19.3552 11.8815 19.5797C12.0293 19.8041 12.2405 19.9796 12.4882 20.0837C12.736 20.1878 13.0091 20.2159 13.2728 20.1644C13.5366 20.1129 13.7791 19.9841 13.9695 19.7945C14.1599 19.6048 14.2896 19.3628 14.3421 19.0993C14.3946 18.8357 14.3676 18.5625 14.2644 18.3144C14.1612 18.0662 13.9866 17.8544 13.7628 17.7057C13.5389 17.557 13.2759 17.4783 13.0072 17.4795C12.6518 17.4842 12.3122 17.6271 12.0604 17.8779C11.8085 18.1288 11.6643 18.4678 11.6583 18.8232Z",
    fill: "#F07F3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbleme);
export default __webpack_public_path__ + "static/media/probleme.afe09afadfc5a12905eb9a100f2a1e15.svg";
export { ForwardRef as ReactComponent };